module.exports = __webpack_public_path__ + "static/media/neu.4a2704ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/neu.svg
// module id = 820
// module chunks = 0